
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import SolutionSearch from "./SolutionSearch";
import SolutionListView from "./SolutionListView";
import SolutionGridView from "./SolutionGridView";
import SolutionsPagination from "./SolutionsPagination";
import { Solution } from "@/types/solutions";

interface SolutionsContentProps {
  solutions: Solution[];
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  viewType: string;
  setViewType: (type: string) => void;
  addToCart: (solution: Solution) => void;
  cart: Solution[];
  getAgencyColor: (agency: string) => string;
  getCommercialTypeColor: (type: string) => string;
  selectedAgencies: string[];
  setSelectedAgencies: (agencies: string[]) => void;
  selectedCreators: string[];
  setSelectedCreators: (creators: string[]) => void;
  selectedCommercialTypes: string[];
  setSelectedCommercialTypes: (types: string[]) => void;
  selectedContentTypes: string[];
  setSelectedContentTypes: (types: string[]) => void;
  solutionSearchQuery: string;
  setSolutionSearchQuery: (query: string) => void;
  priceSort: string;
  setPriceSort: (sort: string) => void;
}

const SolutionsContent: React.FC<SolutionsContentProps> = ({
  solutions,
  searchQuery,
  setSearchQuery,
  viewType,
  setViewType,
  addToCart,
  cart,
  getAgencyColor,
  getCommercialTypeColor,
  selectedAgencies,
  setSelectedAgencies,
  selectedCreators,
  setSelectedCreators,
  selectedCommercialTypes,
  setSelectedCommercialTypes,
  selectedContentTypes,
  setSelectedContentTypes,
  solutionSearchQuery,
  setSolutionSearchQuery,
  priceSort,
  setPriceSort
}) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <SolutionSearch 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          viewType={viewType}
          setViewType={setViewType}
        />

        {viewType === "list" && (
          <div className="mt-0">
            <SolutionListView 
              solutions={solutions}
              addToCart={addToCart}
              cart={cart}
              getAgencyColor={getAgencyColor}
              getCommercialTypeColor={getCommercialTypeColor}
              selectedAgencies={selectedAgencies}
              setSelectedAgencies={setSelectedAgencies}
              selectedCreators={selectedCreators}
              setSelectedCreators={setSelectedCreators}
              selectedCommercialTypes={selectedCommercialTypes}
              setSelectedCommercialTypes={setSelectedCommercialTypes}
              selectedContentTypes={selectedContentTypes}
              setSelectedContentTypes={setSelectedContentTypes}
              solutionSearchQuery={solutionSearchQuery}
              setSolutionSearchQuery={setSolutionSearchQuery}
              priceSort={priceSort}
              setPriceSort={setPriceSort}
            />
          </div>
        )}

        {viewType === "grid" && (
          <SolutionGridView 
            solutions={solutions}
            addToCart={addToCart}
            cart={cart}
            getAgencyColor={getAgencyColor}
            getCommercialTypeColor={getCommercialTypeColor}
          />
        )}

        <SolutionsPagination />
      </CardContent>
    </Card>
  );
};

export default SolutionsContent;
